import React, { useState, useEffect, useContext } from 'react'
import styles from './OrigenFondos.module.css'

//Utiles
import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'
import Subtitle from '../Subtitle'
import MultiSelect from '../MultiSelect'
import GeneralContext from '../../context/GeneralContext'

const OrigenFondos = ({ state, setState, product={} }) => {
  const { state: generalState } = useContext(GeneralContext)
  const [fondos, setFondos] = useState([]);
  const [fondoSelected, setFondoSelected] = useState([]);
  const [otroMonto, setOtroMonto] = useState('');
  const [isActiveOtroMonto, setIsActiveOtroMonto] = useState(false);
  const CODE_FONDOS = 64;

  useEffect(() => {
    obtenerFondos()
  },[])
  
  useEffect(() => {
    if(state.asegurado && state.asegurado.subRespuestas && state.asegurado.subRespuestas.length > 0){
      const myFondos = state.asegurado.subRespuestas.find(({ idBancoPregunta }) => idBancoPregunta === Constantes.COD_PREGUNTA_ORIGIN_FONDOS);
      if(myFondos){
        const listFondos = Funciones.obtenerTablasMaestras(generalState.tablasMaestras, CODE_FONDOS);
        const fondosFormatter = listFondos.map(({ valor }) => ({ label: valor, value: valor }));
        const fondosSelected = myFondos.detalle[0].valor.split(', ').map((value) => {
          const found = fondosFormatter.find(fondo => fondo.value === value);
          if (!found) {
            setIsActiveOtroMonto(true);
            setOtroMonto(value);
            return { label: 'Otro', value: 'Otro' };
          }
          return { label: value, value };
        });
        setFondoSelected(fondosSelected);
      }
    }
  },[state.asegurado])

  const obtenerFondos = () => {
    const listFondos = Funciones.obtenerTablasMaestras(generalState.tablasMaestras, CODE_FONDOS);
    const fondosFormatter = listFondos.map(({ valor }) => ({ label: valor, value: valor }));
    setFondos(fondosFormatter);
  }

  const concatenarFondos = (fondos) => {
    setIsActiveOtroMonto(false);
    setOtroMonto('');
    if(fondos.length === 0){
      setearRespuesta('')
      return;
    }
    const values = fondos.map(({ value }) => {
      const isValueOtro = value === 'Otro';
      if(isValueOtro){
        setIsActiveOtroMonto(true);
      }
     return value
    }).join(', ')

    setearRespuesta(values)
  }

  const handleChangeFondos = async (e) => {
    setFondoSelected(e)
    await concatenarFondos(e);
  }

  const concatenarValorOtrosInput = (text) => {
    const values = fondoSelected.filter(({ value }) => value !== 'Otro').map(({ value }) => value).concat(text).join(', ')
    setearRespuesta(values) 
  }

  const setearRespuesta = (values) => {
    const nuevaRespuesta = values !== '' ? {
      idBancoPregunta: Constantes.COD_PREGUNTA_ORIGIN_FONDOS,
      respuesta: 1,
      detalle: [{ "valor": values }]
    } : null;

    setState((stateAux) => {
      const subRespuestasActualizadas = stateAux.asegurado.subRespuestas.filter(({ idBancoPregunta }) => idBancoPregunta !== Constantes.COD_PREGUNTA_ORIGIN_FONDOS);
      if (nuevaRespuesta) {
        subRespuestasActualizadas.push(nuevaRespuesta);
      }
      return {
        ...stateAux,
        asegurado: {
          ...stateAux.asegurado,
          subRespuestas: subRespuestasActualizadas,
        }
      }
    });
  }

  const handleChangeMonto = (e) => {
    setOtroMonto(e.target.value)
    concatenarValorOtrosInput(e.target.value)
  }

    return (
      <div className={styles.seccionOrigenFondos}>
      <Subtitle
        sname='Declaración de Origen de Fondos'
        smostrar='false'
      />
      <div className={styles.container}>
        <div className={styles.container__row}>
        <div className={styles.container__row__box}>
          <label>La operación requerida por el monto de:</label>
          <input type='text' value={`${product.simboloMoneda} ${Number(product.primaTotal).toLocaleString()}`} disabled />
        </div>
        
        <div className={styles.container__row__box}>
          <label>Tiene el siguiente propósito o destino</label>
          <input type='text' value={product.nombreProducto} disabled />
        </div>
        </div>
        <div className={styles.container__row}>
          <div className={styles.solicitud}>
            <label>Declaro que la cantidad en efectivo es proveniente de:</label>
            <MultiSelect
              className={`${styles.multi_select}`} 
              options={fondos}
              value={fondoSelected}
              onChange={handleChangeFondos}
            />
            {
              !state.campoValidado.origenFondo &&
              <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_ORIGEN_FONDOS}</span>
            }
          </div>  
          {
            isActiveOtroMonto &&
            <div className={styles.container__row__box}>
            <label>Especifique de donde proviene:</label>
            <input
              type='text'
              value={otroMonto}
              onChange={handleChangeMonto}
              onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '')}
            />
            </div>
          }
        </div>
      </div>
      </div>
    )
}

export default OrigenFondos